export const ellipsis = {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
};

export const cellContentStyle = {
  display: '-webkit-box',
  WebkitLineClamp: '5',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  wordBreak: 'break-all',
  whiteSpace: 'normal',
};
export const dotStyle = (color: string | any | ((args: any) => string | undefined), size = 10) => ({
  width: size,
  height: size,
  borderRadius: '50%',
  background: color,
});
export const refetchingStyle = {
  filter: 'blur(3px)',
  opacity: 0.5,
  pointerEvents: 'none',
  userSelect: 'none',
};

export const shadowLogoNode =
  'var(--color-effects-position-default-sm) var(--color-effects-position-default-sm) var(--color-effects-blur-offset-sm) var(--color-effects-spread-none) var(--color-effects-color-default)';

export const shadowSecondaryTopSm =
  'var(--color-effects-position-none) var(--color-effects-position-negative-sm) var(--color-effects-blur-offset-sm) var(--color-effects-spread-none) var(--color-effects-color-default)';

export const shadowSecondaryBottomSm =
  'var(--color-effects-position-none) var(--color-effects-position-default-sm) var(--color-effects-blur-offset-sm) var(--color-effects-spread-none) var(--color-effects-color-default)';

export const shadowSecondaryBottomMd =
  'var(--color-effects-position-none) var(--color-effects-position-default-md) var(--color-effects-blur-offset-md) var(--color-effects-spread-none) var(--color-effects-color-default)';

export const shadowSecondaryBottomLg =
  'var(--color-effects-position-none) var(--color-effects-position-default-lg) var(--color-effects-blur-offset-lg) var(--color-effects-spread-none) var(--color-effects-color-default)';

export const shadowPrimaryBottomSm =
  'var(--color-effects-position-none) var(--color-effects-position-default-sm) var(--color-effects-blur-offset-sm) var(--color-effects-spread-none) var(--color-effects-color-strong), var(--color-effects-position-none) var(--color-effects-position-none) var(--color-effects-blur-ambient-sm) var(--color-effects-spread-none) var(--color-effects-color-default)';

export const shadowPrimaryBottomMd =
  'var(--color-effects-position-none) var(--color-effects-position-default-md) var(--color-effects-blur-offset-md) var(--color-effects-spread-none) var(--color-effects-color-strong), var(--color-effects-position-none) var(--color-effects-position-none) var(--color-effects-blur-ambient-md) var(--color-effects-spread-none) var(--color-effects-color-default)';

export const shadowPrimaryBottomLg =
  'var(--color-effects-position-none) var(--color-effects-position-default-lg) var(--color-effects-blur-offset-lg) var(--color-effects-spread-none) var(--color-effects-color-strong), var(--color-effects-position-none) var(--color-effects-position-none) var(--color-effects-blur-ambient-lg) var(--color-effects-spread-none) var(--color-effects-color-default)';

export const shadowInsetBorder =
  'var(--color-effects-position-none) var(--color-effects-position-none) var(--color-effects-blur-none) var(--color-effects-spread-xs) var(--color-border-base-subdued) inset, var(--color-effects-position-none) var(--color-effects-position-immutable-sm) var(--color-effects-blur-none) var(--color-effects-spread-none) var(--color-border-base-subdued)';
